module.exports = __webpack_public_path__ + "static/media/signal-alt-3.eb44dca6.svg";